import {useState, useRef} from 'react';
import {Button, Row, Col, Form} from 'react-bootstrap';
import {usePortalContext} from '../../lib/context/portalContext';
import withAlerts from '../../lib/withAlerts';
import {compose} from '../../lib/compose';
import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client/react";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCheck, faXmark} from '@fortawesome/pro-solid-svg-icons';
import dateFormat from '../../lib/dateFormat';
import cx from 'classnames';
import {useForm} from 'react-hook-form';
import {useWhitelistMutations} from '../whitelist/whitelistMutations';
import {NIL} from 'uuid';
import {Can} from '../auth/can';

const WhitelistDetails = (props) => {
  const inputRef = useRef(null);
  const {rowData, togglePortal} = usePortalContext();
  const { whitelist_ssid_list_id, id } = rowData ?? {};
  
  const {data} = useQuery(WHITELISTS);
  const whitelists = data?.Whitelists?.result || [];
  

  const [disabled, setDisabled] = useState(true);
  const {success, error} = props.alerts;
  
  const existingWhitelistName = whitelists?.find( ({id}) => id === whitelist_ssid_list_id)?.name ?? null;
  const [defaultValue, setDefaultValue] = useState(whitelist_ssid_list_id);
  // RBAC: SAFECASE_SSID_ASSIGNMENT - note showButton can start `true` here
  // (when no list is assigned yet, the assign form shows immediately with
  // no trigger click), unlike hdmDetails.jsx's equivalent. So this block
  // needs its own <Can> wrap below, not just a gate on the trigger link.
  const [showButton, setShowButton] = useState(whitelist_ssid_list_id === NIL);
  const {register, handleSubmit, formState: { errors } } = useForm();
  const {assign, unassign} = useWhitelistMutations();

  const handleWhitelistAssignment = async () => {
    const list_id = defaultValue ?? undefined;
    
    if(list_id === "select_whitelist" || list_id == undefined || list_id === whitelist_ssid_list_id) {
      return null;
    }
    setDisabled(true);

    const assignDevice = await assign({
      variables: {
        whitelist: {
          whitelist_ssid_list_id: `${list_id}`,
          devices: JSON.stringify([`${id}`]) 
        }
      }          
    })

    if(assignDevice?.errors) {
      const userFacingError = ('List assignment failed.');
      console.error(userFacingError + JSON.stringify(assignDevice?.errors));
      error({msg: userFacingError});
    } else {
      
      success({msg: `List assigned.`});
      setShowButton(false);
      togglePortal();
    }
    
  };

  const unassignWhitelist = async () => {
    const unassignDevice = await unassign({
      variables: {
        whitelist: {
          devices: JSON.stringify([`${id}`])  
        }          
      }
    })

    if(unassignDevice?.errors) {
      const userFacingError = ('List unassignment failed.');
      console.error(userFacingError + JSON.stringify(unassignDevice?.errors));
      error({msg: userFacingError});
    } else {
      
      success({msg: `List unassigned.`});
      setShowButton(false);
      togglePortal();
    }
  }

  const handleButton = (v) => {
    setDefaultValue(v);

    if( v === whitelist_ssid_list_id || v === 'select_whitelist') {
      setDisabled(true);
    } else {
      setDisabled(false); 
    }
  }
  
  return ( <>
    <div className="offcanvas-form" data-testid="offcanvas-safecase">
      <Form className="mb-3" onSubmit={handleSubmit(handleWhitelistAssignment)}>
        
         
        <Row>
          <Col className="mb-3">
            <Form.Group>
              <Form.Label>List Name</Form.Label>
              <div>{existingWhitelistName ?? "No Wi-Fi SSID List Assigned"}</div>
            </Form.Group>
          </Col>
        </Row>
      

        {/* RBAC: SAFECASE_SSID_ASSIGNMENT gates the assign/change form -
            viewing the currently assigned list name above stays visible
            under SAFECASE_VIEW. */}
        <Can code="SAFECASE_SSID_ASSIGNMENT">
          <Row className={cx({'d-none': !showButton})}>
            <Col className="mb-3">
              {existingWhitelistName && <Form.Label>Change Assigned List</Form.Label>}
              {existingWhitelistName === null && <Form.Label>Assign List</Form.Label>}
              <Form.Select
                {...register("whitelist_ssid_list_id")}
                value={defaultValue}
                ref={inputRef}
                disabled={!showButton}
                onChange={e => handleButton(e.target.value)}
              > 
                <option key="select_whitelist" value="select_whitelist">Select Wi-Fi SSID List</option>
                {/* {currentWhitelist && <option key="unassign_whitelist" value="unassign_whitelist">Unassign Whitelist</option>} */}
                {whitelists && whitelists.map(({id, name}, i) => (
                  <option key={id} value={id}>{name}</option>
                ))}
              </Form.Select>
            </Col>
          </Row>

          <Row className={cx({'d-none': !showButton})}>
            <Col className="mb-3">
              <div className="d-grid gap-2">
                <Button disabled={disabled} type="submit">Assign List</Button>
              </div>
            </Col>
          </Row>

          {/* <Row className="mb-3" hidden={!showButton}> */}
          {/*   <Col> */}
          {/*     <a className="link-span privoro-gray" onKeyDown={(e) => setShowButton(false)} onClick={(e) => setShowButton(false)}>Cancel Edit</a> */}
          {/*   </Col> */}
          {/* </Row> */}
          
          <Row className={cx('mb-3', {'d-none': showButton})}>
            <Col>
              <a 
                onKeyDown={() => setShowButton(!showButton)} 
                onClick={() => setShowButton(!showButton)} 
                className={cx({'d-none': showButton}, 'link-span privoro-blue' )}
                >
                Change Assigned List
              </a>
            </Col>
          </Row>
          <Row className={cx('mb-3', {'d-none': showButton})}>
            <Col>
              <span
                role="button"
                onKeyDown={() => unassignWhitelist()} 
                onClick={() => unassignWhitelist()} 
                className={cx({'d-none': showButton}, 'link-span' )}
                >
                Unassign List
              </span>
            </Col>
          </Row>
        </Can>
      </Form>
    </div>
    </> )
}

const WHITELISTS = gql`
  query getWhitelists {
    Whitelists {
      result {
        id
        name
        created_at
        modified_at
      }
      metadata {
        page {
          num
          len
          total
          inPage
          records
        }
      }
    }
  }
`;

export default compose(
  withAlerts,
)(WhitelistDetails);
